export default {
  en: {
    liked_by: {
      zero: 'Be the first one to like this',
      one: 'Liked by %{lastPerson}',
      other: 'Liked by %{lastPerson} and %{remainingCount} others',
    },
  },
};
